import {
  drop,
  each,
  map,
  parseInt,
  reduce,
  size,
  slice,
  split,
  sum,
  uniq,
} from "lodash";
import { CardRow, Layout, Row, TitleRow } from "./model";
import { isCardRow, isTitleRow } from "./row";

export const widthFromLayout = (layout: Layout, index: number): number => {
  const ColumnError = () => ({
    message: `index "${index}" is not in layout "${layout}"!`,
    name: "Invalid column",
  });
  // Parse layout into array of numbers
  const slots = map(drop(split(layout, "_")), parseInt);
  if (size(slots) === 1) {
    // If layout has only one number ("layout_x")
    if (index >= slots[0]) {
      // If index is too high for the row
      throw ColumnError();
    }
    return 1 / slots[0];
  }
  if (size(slots) > 1) {
    // If layout has several numbers ("layout_x_y…")
    if (index >= size(slots)) {
      // If index is too high for the row
      throw ColumnError();
    }
    return slots[index] / sum(slots);
  }
};

export function oneColumnLayout(rows: Row[]): Row[] {
  function isSection(rows: Row[], layout: string) {
    const layouts = uniq(map(rows, "layout"));
    return size(layouts) === 1 && layouts[0] === layout;
  }
  function getTitleRowsIndex(rows: Row[]) {
    for (let i = 0; i < rows.length; i++) {
      if (isTitleRow(rows[i])) {
        return i;
      }
    }
    return rows.length;
  }
  let layout = null;
  let start = -1;
  return reduce(
    rows,
    (acc, row, idx) => {
      if (idx > start) {
        if (isTitleRow(row)) {
          layout = row.layout;
          const lastIndex = idx + getTitleRowsIndex(slice(rows, idx + 1));
          const nextRows = slice(rows, idx, lastIndex + 1);
          if (isSection(nextRows, layout)) {
            const newRows = [];
            const length = nextRows.length;
            each(nextRows, (l, rowIdx) => {
              if (isTitleRow(l)) {
                each(l.titles, (title, position) => {
                  const newRow: TitleRow = {
                    layout: Layout.Row_1,
                    type: "title",
                    style: l.style,
                    titles: [title],
                  };
                  newRows[position * length + rowIdx] = newRow;
                });
              } else if (isCardRow(l)) {
                each(l.cards, (card, position) => {
                  const newRow: CardRow = {
                    type: "card",
                    layout: Layout.Row_1,
                    cards: [card],
                  };
                  newRows[position * length + rowIdx] = newRow;
                });
              }
            });
            each(newRows, (row) => {
              acc.push(row);
            });
            start = lastIndex;
            layout = null;
          } else {
            acc.push(row);
            layout = null;
          }
        } else {
          acc.push(row);
        }
      }
      return acc;
    },
    []
  );
}
